import Phaser from 'phaser';
import { gameConfig } from '@/config/gameConfig';
import { initSentry } from '@/sentry';

// Initialize error tracking
initSentry();

// Create and start the game
const game = new Phaser.Game(gameConfig);

// Handle visibility changes (pause when tab is hidden)
document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    game.scene.scenes.forEach((scene) => {
      if (scene.scene.isActive()) {
        scene.scene.pause();
      }
    });
  } else {
    game.scene.scenes.forEach((scene) => {
      if (scene.scene.isPaused()) {
        scene.scene.resume();
      }
    });
    // Re-enable input system after resuming
    game.input.enabled = true;
    game.canvas.focus();
  }
});

// Expose game instance for debugging in development
if (import.meta.env.DEV) {
  (window as unknown as { game: Phaser.Game }).game = game;
}
